import axios from 'axios';
import { API_url } from '../api.setup';
import { FieldAgentsModel } from 'src/models/servicePartner/feildAgentModel';

const API_Controller = '/fieldAgent';

export const FieldAgentServices = {
  getAllData: async (dataId: number) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/getFieldAgentByServicePartnerId?servicePartnerId=${dataId}`
      );

      // Transform the response data to match FieldAgentsModel
      const transformedData: FieldAgentsModel[] = response.data.map((agent: any) => ({
        id: agent.id,
        servicePartnerId: agent.servicePartner?.id || 0, // Extract ID safely
        firstName: agent.firstName,
        lastName: agent.lastName,
        emailId: agent.emailId,
        addressLine1: agent.addressLine1,
        addressLine2: agent.addressLine2,
        cityId: agent.city?.id || 0, // Extract city ID safely
        areaId: agent.area?.id || 0, // Extract area ID safely
        mobileNumber: agent.mobileNumber,
        mobileNumber2: agent.mobileNumber2 || "",
        adharNumber: agent.adharNumber,
        panNumber: agent.panNumber,
        dateOfJoining: agent.dateOfJoining,
        isActive: agent.isActive
      }));

      return transformedData;

    } catch (error) {
      throw error;
    }
  },

  addData: async (data: FieldAgentsModel) => {
    try {
      const response = await axios.post(`${API_url}${API_Controller}`, data);
      return response.data as FieldAgentsModel;
    } catch (error) {
      console.error('error', error)
      throw error;
    }
  },

  editData: async (data: FieldAgentsModel) => {
    try {
      const response = await axios.put(`${API_url}${API_Controller}/update`, data);
      return response.data as FieldAgentsModel;
    } catch (error) {
      throw error;
    }
  },

  deleteData: async (dataId: number) => {
    try {
      const response = await axios.delete(
        `${API_url}${API_Controller}/delete?id=${dataId}`
      );
      return response.data as FieldAgentsModel;
    } catch (error) {
      throw error;
    }
  },
  getFieldAgentwithAvailabilityData: async (servicePartnerId: number, date: string, timeSlotId: number) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/getFieldAgentWithAvailabilityByServicePartnerId?servicePartnerId=${servicePartnerId}&date=${date}&timeSlotId=${timeSlotId}`
      );

      // Transform the response data to match FieldAgentsModel
      const transformedData: FieldAgentsModel[] = response.data.map((agent: any) => ({
        id: agent.id,
        servicePartnerId: agent.servicePartner?.id || 0, // Extract ID safely
        firstName: agent.firstName,
        lastName: agent.lastName,
        emailId: agent.emailId,
        addressLine1: agent.addressLine1,
        addressLine2: agent.addressLine2,
        cityId: agent.city?.id || 0, // Extract city ID safely
        areaId: agent.area?.id || 0, // Extract area ID safely
        mobileNumber: agent.mobileNumber,
        mobileNumber2: agent.mobileNumber2 || "",
        adharNumber: agent.adharNumber,
        panNumber: agent.panNumber,
        dateOfJoining: agent.dateOfJoining,
        isActive: agent.isActive,
        available: agent.available
      }));

      return transformedData;

    } catch (error) {
      throw error;
    }
  },
};
